window.addEventListener('DOMContentLoaded', function() {
    const facetPanels = document.querySelectorAll('.facets__panel');

    facetPanels.forEach(function(panel) {
        if (panel.id === "Facet-Details-template--25559921525059__main-filter-p-product_type") {
            // questo rimane aperto
            return;
        }

        if (panel.open) {
            panel.open = false;
        }
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const chatLinks = document.querySelectorAll('a[href="#n8n-chat"]');
    const toggleBtn = document.querySelector('#n8n-chat .chat-window-toggle');

    if (!toggleBtn || !chatLinks.length) return;

    chatLinks.forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();          // evita lo scroll all’ancora
        toggleBtn.click();           // simula il click sul toggle della chat
      });
    });
  });